<nav class="flex flex-col space-y-2">
  <app-navigation-item [item]="firstItem$ | async"></app-navigation-item>

  <span dashboard-menu class="dashboard-menu"></span>
  @for (item of other$ | async; track item.name) {
    <ng-template [ngxPermissionsOnly]="item.permission ? item.permission : []">
      <app-navigation-item [item]="item"></app-navigation-item>
    </ng-template>
  }
</nav>
